module.exports = __webpack_public_path__ + "img/empty-coin.16773095.svg";